"use client";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import "../../../foundation/iconography/ExtraIconsProvider.js";
import "../../../foundation/iconography/IconVariantProvider.js";
import "../../../foundation/iconography/icons.js";
import { Icon } from "../../../foundation/iconography/Icon.js";
import { BodyText } from "../../../foundation/typography/index.js";
import * as React from "react";
import classNames from "classnames";
import "../../../foundation/logos/Logo.css.js";
import { tokens } from "@gnist/themes/tokens.css.js";
import { ScreenReaderOnly } from "../../../utilities/accessibility/ScreenReaderOnly.js";
import "../../../utilities/accessibility/visuallyHidden.css.js";
import { Spinner } from "../../progress/Spinner.js";
import { boxedButton, actionText } from "./styles.css.js";
const BoxedButtonBase = React.forwardRef(function BoxedButtonBase2({ $as, as, children, className, loading, disabled = loading == null ? void 0 : loading.isLoading, type = "button", density = "default", ...props }, ref) {
  const buttonProps = {
    ...props,
    disabled: (loading == null ? void 0 : loading.isLoading) === true ? loading.isLoading : disabled,
    className: classNames(className, boxedButton({ density })),
    type,
    ref
  };
  return React.createElement($as ?? as ?? "button", buttonProps, jsxs(Fragment, { children: [React.Children.map(children, (child) => {
    if (React.isValidElement(child) && child.type === Icon) {
      return React.cloneElement(child, {
        size: density === "compact" ? "m" : "l"
      });
    }
    if (typeof child === "string") {
      return jsx(BodyText, { className: actionText, children: child });
    }
    return child;
  }), (loading == null ? void 0 : loading.isLoading) && (loading == null ? void 0 : loading.loadingText) && jsx(Spinner, { diameter: tokens.size[density === "compact" ? "xs" : "s"], textDescription: loading == null ? void 0 : loading.loadingText }), jsx(ScreenReaderOnly, { "aria-live": "polite", children: (loading == null ? void 0 : loading.isLoading) && loading.loadingText })] }));
});
export {
  BoxedButtonBase
};
